import { contrastRatio, HSLColor } from '@yola/yola-palette-generator';
import mediumEmphasis from '../../../text/medium-emphasis';

const primary = ({ targetColor, backgroundColor }) => {
  if (contrastRatio(backgroundColor, targetColor) >= 4.5) {
    return mediumEmphasis({ targetColor, backgroundColor });
  }

  const { hue, saturation, lightness } = targetColor;
  return new HSLColor(hue, saturation, lightness, 0.4);
};

export default primary;
